import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
	RHookFormDatePicker,
} from "@websential/cosmic-v20";
import React, { useEffect, useState } from "react";

import { Grid } from "@mui/material";


interface IStatutoryHolidayReportHeader {
	setStateRunGetListAPICall: (value: boolean) => void
	payPeriodFrequencyDDLItems: any;
	employeeDDLItems: any;
	payPeriodEndDateDDL: any;
	provinceDDL: any;
	statutoryHolidayDDL: any;
	onPeriodEndDateSelectionChangeHandler: (value: string) => void
	formMethods: any
}

export const StatutoryHolidayReportHeader: React.FC<
	IStatutoryHolidayReportHeader
> = ({ setStateRunGetListAPICall, payPeriodFrequencyDDLItems, employeeDDLItems, payPeriodEndDateDDL, provinceDDL, statutoryHolidayDDL, onPeriodEndDateSelectionChangeHandler, formMethods }) => {

	const [isEndDateDisabled, setIsEndDateDisabled] = useState<boolean>(true);
	const [stateIsDateRangeDisabled, setStateIsDateRangeDisabled] = useState<boolean>(false);

	const onPayPeriodSelectionChangeHandler = (e: any) => {
		setStateRunGetListAPICall(false)
		onPeriodEndDateSelectionChangeHandler(e.value);
		setIsEndDateDisabled(e.value === "all")

		if (e.value === "all") {
			formMethods.setValue("payPeriodEndDate", "all");
			setStateIsDateRangeDisabled(false)
		}
	}

	const onPayPeriodEndDateSelectionChangeHandler = ({ value }: any) => {

		setStateRunGetListAPICall(false);

		const isAll = value === "all";
		setStateIsDateRangeDisabled(!isAll);

		if (isAll) return;
		const selectedLabel = payPeriodEndDateDDL && payPeriodEndDateDDL?.find(
			(item: any) => item.value === value
		)?.label;

		if (!selectedLabel) return;

		const [startDate, endDate] = selectedLabel.split(" to ");

		formMethods.setValue("startDate", new Date(startDate));
		formMethods.setValue("endDate", new Date(endDate));
	};

	// useEffect(()=>{

	// },)

	return (
		<>
			<Grid
				container
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				sx={{
					background: "#fff",
					border: "1px solid #e5e7eb",
					borderBottom: 0,
					borderRadius: "2px 2px 0 0",
					padding: "31px 20px 1rem 20px",
					marginBottom: "0px!important",
				}} columnSpacing={2}>

				<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
					<EnhancedDropDownRHFWithLabel
						selectName={"provinceId"}
						items={provinceDDL ?? []}
						selectedItem={"all"}
						label={"Province"}
						testId={"province-ddl"}
					// onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
					/>
				</Grid>

				<Grid size={{ xs: 12, sm: 12, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
				<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
					<EnhancedDropDownRHFWithLabel
						selectName={"employeeId"}
						items={employeeDDLItems ?? []}
						selectedItem={"all"}
						label={"Employee"}
						testId={"employee-ddl"}
						onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
					/>
				</Grid>

				<Grid size={{ xs: 12, sm: 12, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
				<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
					<EnhancedDropDownRHFWithLabel
						selectName={"holidayDate"}
						items={statutoryHolidayDDL ?? []}
						selectedItem={"all"}
						label={"Holiday"}
						testId={"holiday-ddl"}
						onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
					/>
				</Grid>

				<Grid size={{ xs: 12, sm: 12, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
				<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
					<EnhancedDropDownRHFWithLabel
						selectName={"payPeriod"}
						items={payPeriodFrequencyDDLItems ?? []}
						selectedItem={"all"}
						label={"Pay Period Type"}
						testId={"pay-period-type-ddl"}
						// onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
						onSelectionChangeHandler={onPayPeriodSelectionChangeHandler}
					/>
				</Grid>

				<Grid size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
				<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
					<EnhancedDropDownRHFWithLabel
						selectName={"payPeriodEndDate"}
						items={payPeriodEndDateDDL ?? []}
						selectedItem={"all"}
						label={"End Date"}
						testId={"end-date-ddl"}
						// // onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
						onSelectionChangeHandler={onPayPeriodEndDateSelectionChangeHandler}
						isDisabled={isEndDateDisabled}

					/>
				</Grid>

				<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
					<Grid
						size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
						sx={{
							"& .MuiBox-root": {
								padding: "0pxImportant",
							},
							"& .calenderWrapper ": {
								minWidth: "178px!important"
								// fontSize: ".875rem" 
							}
						}}>
						<RHookFormDatePicker
							name="startDate"
							testId="start-date"
							label="Date Range"
							format="M dd, yy"

							disabled={stateIsDateRangeDisabled}
						// onDateSelectionChangeHandler={onSatrtDateSelectionChnageHandler}
						/>
					</Grid>

					<Grid size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
					<Grid
						size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
						sx={{
							"& .MuiBox-root": {
								padding: "0pxImportant",
							},
							"& .calenderWrapper ": {
								marginTop: "15px!important",
								marginBottom: "0!important",
								minWidth: "178px!important"
								// fontSize: ".875rem" 
							}
						}}>
						<RHookFormDatePicker
							name="endDate"
							testId="end-date"
							label=""
							format="M dd, yy"
							disabled={stateIsDateRangeDisabled}
						// onDateSelectionChangeHandler={onEndDateSelectionChnageHandler}
						/>
					</Grid>
				</Grid>
				<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
					<EnhancedButtonPrimeReact
						label="Apply Filter"
						raised
						type="submit"
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
					/>
				</Grid>
			</Grid>
		</>
	);
};
